module.exports = __webpack_public_path__ + "static/media/DSC_9571_Small.d9499b6b.jpg";